import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";

import api from "../../api";
import "./index.css";
import ApiCaller from "../../api/apiCaller";
import * as utils from "../../resources/utils"
import { UserInfo } from "model/user";

export default function NavigationBar() {
  const [isOpen, setIsOpen] = useState(false);
  const [hasUser, setHasUser] = useState(false);
  const [currentUser, setCurrentUser] = useState();

  // permissions
  const roleAccessAdvancedFeatures = ["Admin", "Company Admin", "Data Practitioner"];
  const canAccessAdvancedFeatures = currentUser?.roles.some(userRole => roleAccessAdvancedFeatures.includes(userRole.name));

  useEffect(() => {
    const user = api.getCurrentUser();
    if (user) {
      setCurrentUser(user);
      setHasUser(true);
    }
  }, []);

  const logout = async () => {
    //eslint-disable-next-line
    const r = confirm("Are you sure to log out?");
    if (r) {
      const res = await ApiCaller.post("user/logout");
      Cookies.remove("access_token");
      Cookies.remove("user");
      Cookies.remove("company_id");
      setHasUser(false);
      window.location.href = '/login';
      window.location.reload();
    }
  };

  return (
    <div>
      <Navbar className="app-navigation-header" expand="md" color="white" dark>
        <NavbarBrand className="app-navigation-header-home-logo-text" href="/">
          <img
            src="/images/sc_logo.png"
            alt="Seedcom DataDex"
            style={styles.logo}
          />
          <span style={styles.brandName}>DataDex</span>
        </NavbarBrand>
        <NavbarToggler
          onClick={() => {
            setIsOpen(!isOpen);
          }}
          style={{ borderColor: "white" }}
        />
        <Collapse isOpen={isOpen} navbar>
          <Nav className="mr-auto" navbar>
            <NavItem style={styles.navItem}>
              {hasUser &&
                <NavLink
                  className="app-navigation-header-item-text"
                  href="/dictionary"
                >
                  Data Dictionary
                </NavLink>
              }
            </NavItem>
            {canAccessAdvancedFeatures &&
              <NavItem style={styles.navItem}>
                <NavLink
                  className="app-navigation-header-item-text"
                  href="/schedule_queries"
                >
                  Schedule Queries
                </NavLink>
              </NavItem>
            }
            {canAccessAdvancedFeatures &&
              <NavItem style={styles.navItem}>
                <NavLink
                  className="app-navigation-header-item-text"
                  href="/transformations"
                >
                  Transformations
                </NavLink>
              </NavItem>
            }
            {canAccessAdvancedFeatures &&
              <NavItem style={styles.navItem}>
                <NavLink
                  className="app-navigation-header-item-text"
                  href="/data_pipeline"
                >
                  Data Pipelines
                </NavLink>
              </NavItem>
            }
            {/* {canAccessAdvancedFeatures &&
              <NavItem style={styles.navItem}>
                <NavLink
                  className="app-navigation-header-item-text"
                  href="/monitoring"
                >
                  Monitoring
                </NavLink>
              </NavItem>
            } */}
            {hasUser &&
              <NavItem style={styles.navItem}>
                <NavLink
                  className="app-navigation-header-item-text"
                  onClick={() => utils.default.openLinkInNewTab("http://docs.datadex.ficus.ai/docs/intro")}
                >
                  Docs
                </NavLink>
              </NavItem>
            }
          </Nav>
          {!isOpen && (
            <Nav className="ml-auto" navbar>
              {currentUser && (
                <NavItem>
                  <NavLink
                    className="app-navigation-header-avatar"
                    href="/reset_password"
                  >
                    <div>
                      <span>
                        {(currentUser.first_name &&
                          currentUser.first_name.charAt(0)) || ""}
                        {currentUser.last_name &&
                          currentUser.last_name.charAt(0)}
                      </span>
                    </div>
                  </NavLink>
                </NavItem>
              )}
              <NavItem>
                <NavLink
                  className="app-navigation-header-logout-button"
                  onClick={logout}
                >
                  {hasUser ? "Logout" : ""}
                </NavLink>
              </NavItem>
            </Nav>
          )}
        </Collapse>
      </Navbar>
    </div>
  );
}

const styles = {
  navItem: { marginLeft: 20 },
  logo: {
    width: 30,
    height: 32,
  },
  brandName: {
    color: "var(--color-accent-dark)",
    marginLeft: 12,
  },
};
